"use strict";
// A web interface to manage a trail guide mobile app's content and data.
// Copyright (C) 2021-2025  David Lougheed
// See NOTICE for more information.
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var antd_1 = require("antd");
var icons_1 = require("@ant-design/icons");
var hooks_1 = require("../../hooks");
var utils_1 = require("../../utils");
var AssetTypeIcon = react_1.default.memo(function (_a) {
    var type = _a.type;
    switch (type) {
        case "image":
            return react_1.default.createElement(icons_1.PictureOutlined, null);
        case "audio":
            return react_1.default.createElement(icons_1.SoundOutlined, null);
        case "video":
            return react_1.default.createElement(icons_1.VideoCameraOutlined, null);
        case "video_text_track":
        case "pdf":
            return react_1.default.createElement(icons_1.FileTextOutlined, null);
    }
    return react_1.default.createElement("span", null);
});
var AssetPreview = react_1.default.memo(function (_a) {
    var asset = _a.asset;
    if (!asset)
        return react_1.default.createElement("div", null);
    switch (asset.asset_type) {
        case "audio":
            return react_1.default.createElement("audio", { controls: true },
                react_1.default.createElement("source", { src: (0, utils_1.assetIdToBytesUrl)(asset.id) }));
        case "image":
            return react_1.default.createElement("img", { src: (0, utils_1.assetIdToBytesUrl)(asset.id), style: { maxWidth: 500, width: "100%" }, alt: asset.file_name });
        case "video":
            return react_1.default.createElement("video", { width: 480, height: 270, controls: true },
                react_1.default.createElement("source", { src: (0, utils_1.assetIdToBytesUrl)(asset.id) }));
    }
    return react_1.default.createElement("div", null);
});
var AssetDetailView = react_1.default.memo(function () {
    var _a, _b, _c, _d, _e, _f, _g;
    var navigate = (0, react_router_dom_1.useNavigate)();
    var assetID = (0, react_router_dom_1.useParams)().id;
    var assetsInitialFetch = (0, hooks_1.useAppSelector)(function (state) { return state.assets.initialFetchDone; });
    var assetsFetching = (0, hooks_1.useAppSelector)(function (state) { return state.assets.isFetching; });
    var asset = (0, hooks_1.useAppSelector)(function (state) { return (0, utils_1.findItemByID)(state.assets.items, assetID); });
    var onBack = (0, react_1.useCallback)(function () { return navigate(-1); }, [navigate]);
    var title = (0, react_1.useMemo)(function () { return (!assetsInitialFetch && assetsFetching)
        ? "Loading..."
        : react_1.default.createElement("span", null,
            "Asset: ",
            react_1.default.createElement(AssetTypeIcon, { type: asset === null || asset === void 0 ? void 0 : asset.asset_type }),
            " ", asset === null || asset === void 0 ? void 0 :
            asset.file_name); }, [assetsInitialFetch, assetsFetching, asset]);
    return react_1.default.createElement(antd_1.PageHeader, { ghost: false, onBack: onBack, title: title },
        react_1.default.createElement(antd_1.Descriptions, { bordered: true, size: "small" },
            react_1.default.createElement(antd_1.Descriptions.Item, { label: "ID" },
                react_1.default.createElement("span", { style: { fontFamily: "monospace" } }, (_a = asset === null || asset === void 0 ? void 0 : asset.id) !== null && _a !== void 0 ? _a : "")),
            react_1.default.createElement(antd_1.Descriptions.Item, { label: "File Name", span: 2 }, (_b = asset === null || asset === void 0 ? void 0 : asset.file_name) !== null && _b !== void 0 ? _b : ""),
            react_1.default.createElement(antd_1.Descriptions.Item, { label: "Type", span: 1 }, (_c = asset === null || asset === void 0 ? void 0 : asset.asset_type) !== null && _c !== void 0 ? _c : ""),
            react_1.default.createElement(antd_1.Descriptions.Item, { label: "File Size", span: 3 },
                (((_d = asset === null || asset === void 0 ? void 0 : asset.file_size) !== null && _d !== void 0 ? _d : 0) / 1000).toFixed(0),
                " KB"),
            react_1.default.createElement(antd_1.Descriptions.Item, { label: "Times used (total)", span: 1 }, ((_e = asset === null || asset === void 0 ? void 0 : asset.times_used_by_all) !== null && _e !== void 0 ? _e : "").toString()),
            react_1.default.createElement(antd_1.Descriptions.Item, { label: "Times used (enabled)", span: 2 }, ((_f = asset === null || asset === void 0 ? void 0 : asset.times_used_by_enabled) !== null && _f !== void 0 ? _f : "").toString()),
            react_1.default.createElement(antd_1.Descriptions.Item, { label: "SHA1 Checksum", span: 3 },
                react_1.default.createElement("span", { style: { fontFamily: "monospace" } }, (_g = asset === null || asset === void 0 ? void 0 : asset.sha1_checksum) !== null && _g !== void 0 ? _g : ""))),
        react_1.default.createElement(antd_1.Card, { size: "small", title: "Preview", style: { marginTop: 16 } },
            react_1.default.createElement(AssetPreview, { asset: asset })));
});
exports.default = AssetDetailView;
